<template>
    <div class="c-form-item">
        <picture-input v-if="hasFetch || !selected"
                ref="pictureInput"
                :prefill="hasFetch ? selected : null"
                :prefillOptions="{
                    fileType: 'png',
                    mediaType: 'image/png'
                }"
                :width="width"
                :removable="true"
                :height="height"
                removeButtonClass="ui red button"
                accept="image/jpeg, image/png, image/gif"
                size="10"
                buttonClass="ui button primary"
                @change="onChanged"
                @remove="onRemoved"
                @error="onError"
                :alertOnError="false"
                :customStrings="{
                  upload: '<h1>Upload it!</h1>',
                  drag: 'Drag and drop your image here'
                }">
        </picture-input>
        <img v-else :src="selected" :width="width" :height="height" alt="">

        <button v-if="!hasFetch && selected" class="ui red button u-margin-top-small u-margin-bottom--small" @click.prevent="onRemoved">Remove Photo</button>
        
        <!--<v-error v-if="error">
            <slot name="error">{{ error }}</slot>
        </v-error>-->
    </div>
</template>

<script>
    import PictureInput from 'vue-picture-input'
    import VError from '@/components/form/Error'

    export default {
        components: {
            PictureInput,
            VError
        },
        props: {
            width: {
                type: [String, Number]
            },
            height: {
                type: [String, Number]
            },
            selected: {
                type: [String],
                default: null
            },
            error: String
        },
        data() {
          return {
              image: null,
              hasFetch: false
          }
        },
        created() {
          if (window.fetch) { this.hasFetch = true; }
          },
        methods: {
            onChanged() {
                if (this.$refs.pictureInput.file) {
                    this.image = this.$refs.pictureInput.image;
                    this.$emit('changed', this.image);
                    if (!window.fetch) { this.hasFetch = false; }
                } else {
                    console.log("Old browser. No support for Filereader API");
                }
            },
            onRemoved() {
                this.image = null;
                this.hasFetch = true;
                this.$emit('changed', null);
            },
            onError(){
                this.onRemoved();
                this.$notify({
                            group: 'global',
                            title: this.$t('warranty.procedure.fileSizeExceeds_label'),
                            type: 'error',
                            duration: 5000
                        });
            }
        }
    }
</script>

<style lang="scss">
    .picture-input {
        .button {
            position: absolute;
            top: -20px;
            right: -180px;
            width: 150px;
            &.red {
                top: 30px;
            }
        }
    }
    .picture-inner {
        margin: 0.4em auto !important;
        border: .1em dashed rgba(66,66,66,.15) !important;
        .picture-inner-text {
            font-size: 0.75em !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/form/PictureInput.vue